import { render } from "./NoCertificate.vue?vue&type=template&id=fba2af6c&scoped=true"
import script from "./NoCertificate.vue?vue&type=script&lang=js"
export * from "./NoCertificate.vue?vue&type=script&lang=js"

import "./NoCertificate.vue?vue&type=style&index=0&id=fba2af6c&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba2af6c"]])

export default __exports__